import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap';
import {Principal} from 'src/app/core';
import {ClauseExtensionMySuffixService} from 'src/app/entities/clause-extension-my-suffix/clause-extension-my-suffix.service';
import {CurrencyService} from 'src/app/entities/currency';
import {currenyMaskService} from 'src/app/shared/currencyMask.service';
import {IDelegation} from 'src/app/shared/model/delegation.model';
import {IUnderwriterInsurerMySuffix} from 'src/app/shared/model/underwriter-insurer-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {DelegationMySuffixService} from './../../../underwriter-insurer-my-suffix/delegation-my-suffix.service';
import {UnderwriterInsurerMySuffixService} from './../../../underwriter-insurer-my-suffix/underwriter-insurer-my-suffix.service';

@Component({
  selector: 'jhi-delegation-my-suffix-detail',
  templateUrl: './delegation-my-suffix-detail.component.html',
  styleUrls: []
})
export class DelegationMySuffixDetailComponent implements OnInit {

  @ViewChild('warningModel') warningModel: ModalDirective;
  @ViewChild('invalidSecurityModel') invalidSecurityModel: ModalDirective;

  delegation: IDelegation;

    signatureUrl: any;
    isUrlPresent = false;
    imageToShow: any;
    isShowFutureHistory: boolean;
  isShowPastHistory: boolean;

  historyData = [];
  historyTitle: string;
  historyType: string;
  historyId: number;
    
  parentHistoryToggle = false;
  parentFutureHistoryToggle=false;
  
  underwriterId;
  usedCurrenciesRate=[]
  currencyListWithRate=[]
  underwriterInsurers: IUnderwriterInsurerMySuffix[]=[];

  public readonly RoleUtil=RoleUtil;
  
  constructor(
    private jhiAlertService: JhiAlertService,
    // private underwriterService: UnderwriterMySuffixService,
    private activatedRoute: ActivatedRoute,
    private languageChangeService: LanguageChangeService,
    private router: Router,
    private principal: Principal,
    // private modalService: BsModalService,
    // private confirmationModelService: ConfirmationModelService,
    private delegationService: DelegationMySuffixService,
    private currenyMask: currenyMaskService,
    private currencyService: CurrencyService,
    private underwriterInsurerService: UnderwriterInsurerMySuffixService,
    private clauseExtensionMySuffixService: ClauseExtensionMySuffixService,
  ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
  }

  ngOnInit() {
    this.isShowPastHistory = this.principal.isShowPastHistory;
    this.underwriterId=this.activatedRoute.snapshot.params['uId'];
    
    this.activatedRoute.data.subscribe(({delegation}) => {
      this.delegation=delegation.payload;

      this.usedCurrenciesRate=[];

      this.delegation.insuranceCompanySecurity.forEach(security => {
        if(this.usedCurrenciesRate.filter(currency => currency.currency==security.shareAmountCurrencyName).length==0) {
          if(security.shareAmountCurrencyName!='EUR') {
            this.usedCurrenciesRate.push({
              "currency": security.shareAmountCurrencyName,
              "rate": security.shareAmountCurrencyRateToEUR
            });
          }
        }
        if(this.usedCurrenciesRate.filter(currency => currency.currency==security.insurerAuthLimitCurrencyName).length==0) {
          if(security.insurerAuthLimitCurrencyName!='EUR') {
            this.usedCurrenciesRate.push({
              "currency": security.insurerAuthLimitCurrencyName,
              "rate": security.authLimitAmountCurrencyRateToEUR
            });
          }
        }
      });

      this.underwriterInsurerService.findByUnderwriterId(this.underwriterId).subscribe(res => {
        this.underwriterInsurers=res.body;
      });

      this.currencyService.query('/get-currency-list-name-id-rate').subscribe(res => {
        this.currencyListWithRate=res.payload;

        // let delegationCurrency: any[]=this.currencyListWithRate.filter(currency => currency.name==this.delegation.limitCurrencyName);
        // let eurRate=this.currencyListWithRate.filter(currency => currency.name=='EUR');
        // let delegationCurrencyRate=eurRate[0].rate;

        // if(delegationCurrency.length>0) {
        //   delegationCurrencyRate=delegationCurrency[0].rate;
        // }

       
      });
      if (this.delegation.fileDTO && this.delegation.fileDTO.fileId) {
        this.clauseExtensionMySuffixService.downloadFileService(this.delegation.fileDTO.fileId).subscribe(
          response => {
            this.createImageFromBlob(response);
          },
          err => {
            console.log(err);
            this.jhiAlertService.error("File not found");
          }
        );
      }

    });
    
    this.languageChangeService.refreshLanguage();
    this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
        const refresh = paramMap.get('refresh');
        if (refresh) {
             
            this.languageChangeService.refreshLanguage();
            window.history.back();
        }
    });

  }


  viewHistory(Obj) {
    this.parentHistoryToggle = true;
    if(Obj.delegationNumber) {
      this.historyTitle = 'Delegation (' + Obj.delegationNumber + ') History';
    } else {
        this.historyTitle = 'Delegation History';
    }
    this.historyType = "DELEGATION_AUDIT";
    this.historyId = Obj.id;
}

viewFutureHistory(Obj) {
    this.parentFutureHistoryToggle = true;
    this.historyTitle = 'Delegation Future Records';
    this.historyType = "DELEGATION_AUDIT";
    this.historyId = Obj.id;
}
hideFutureHistorySidebar() {
    if (document.getElementById("future-history-window")) {
        this.parentHistoryToggle = false;
        this.parentFutureHistoryToggle = false;
    }
}
  
previousState() {
  window.history.back();
}
  
receiveToggleEvent($event) {
  this.parentHistoryToggle = $event;
  this.parentFutureHistoryToggle = $event;
}
  
  
checkAndProceedForRenew() {
  if(this.delegation&&this.delegation.expiryDate&&new Date(this.delegation.expiryDate)>=new Date()) {
    this.warningModel.show();
  } else {
    this.proceedForRenewal();
  }
}
  
  warningModelHide() {
    this.warningModel.hide();
  }

  proceedForRenewal() {
    this.warningModel.hide();
    this.router.navigate(['/data-management/underwriter/delegation/renew', this.underwriterId, this.delegation.id, 'edit']);
  }

  
  checkForEditAndRedirect(delegationId) {
    // check in policies if this delegation is present
    this.delegationService.checkForDelegations(delegationId).subscribe(res => {
        if(res && res.body && res.body.payload && res.body.payload.length==0) {
            this.router.navigate(['/data-management/underwriter/delegation',this.underwriterId,delegationId,'edit']);
        } else {
            let policies: string=' ';
            res.body.payload.forEach(pol => policies=policies+pol.policyNo+",");
            policies.slice(policies.length-1,policies.length);
            this.jhiAlertService.error('Delegation can not be edited as its part of polices :: '+policies);
        }
    });
  }

  hideInvalidSecurityModel() {
    this.invalidSecurityModel.hide();
  }

  selectedSecurity;
  viewSecurityDetails(security) {
    this.underwriterInsurers.forEach(data => {
      if(data.insurancecompany.id==security.insuranceCompany.id) {
        let obj={
          "shareAmountCurrency": this.delegation.limitCurrencyName,
          "shareAmount": security.shareAmount,
          "convertedShareAmount": security.convertedShareAmount,
          "authorizationLimitCurreny": data.limitCurrencyName,
          "authorizationLimit": data.authorizationLimit,
          "convertedAuthLimitAmount": security.convertedAuthLimitAmount,
          "currencyConvertedDate": security.currencyRateDateTime,
          "shareAmountToAuthLimitCurrency":security.shareAmountToAuthLimitCurrency
        }
    
        this.selectedSecurity=obj;

        this.invalidSecurityModel.show();
      }
    });
  }
createImageFromBlob(image: Blob) {
  let reader = new FileReader();
  reader.addEventListener(
    'load',
    () => {
      this.imageToShow = reader.result;
    },
    false
  );

  if (image) {
    reader.readAsDataURL(image);
  }
}
  
}
